// This file was automatically generated from appchart.dialog.discontinueRx.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.discontinueRx');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.medOrderThread');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.discontinueRx.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><form><div class="el8FieldSection"><label class="el8label el8FieldMedium el8LgText">D/C:</label><div id="discontinue-rx-med-info" class="el8FieldMediumLabelPadding el8Wrap"></div></div><div class="el8FieldSection"><label class="el8label el8FieldMedium">Reason:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="reason"></textarea></div></div>', (opt_data.isDocumented) ? '<div class="el8FieldSection"><label class="el8label el8FieldMedium">By:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap prescriber-field"></div></div>' : '', '<div class="el8FieldSection"><label class="el8label el8FieldMedium">D/C Date:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap datePickerWrap"><input type="text" class="datePicker" name="discontinueDate"/></div></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.discontinueRx.threadInfo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8LargeFontSize">');
  el8.template.ptdata.model.medOrderThread.summary(opt_data, output);
  output.append('</p><p><span class="el8SystemText">(Last activity date: ', (soy.$$escapeHtml(opt_data.latestActivityDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.latestActivityDate)) : ''), ')</span></p>');
  if (!opt_sb) return output.toString();
};
